import * as React from 'react';
import { AUTHENTICATION_PROVIDER, AuthType, STYLOVYZE_FLAGS, } from '../../types';
import { AboutBoxContent } from './AboutBoxContent';
import { StyledAboutBox } from './AboutBox.styles';
import { UserEmulation } from '../../hocs/ApplicationWrapper/features/UserEmulation';
import { useIsFeatureEnabled } from '../../utils';
import { useSelectUserContextEmulation } from '../../selectors/userContext.selectors';
/**
 * Add a description for your component here
 */
export const AboutBox = ({ title, open, setOpen, banner, textboxSrc, textBoxContent, }) => {
    const inEmulation = useSelectUserContextEmulation();
    const advSupportEnabled = !!useIsFeatureEnabled(STYLOVYZE_FLAGS.ADVANCED_SUPPORT);
    const isForge = localStorage.getItem(AUTHENTICATION_PROVIDER) == AuthType.Forge;
    const advSupportAllowed = advSupportEnabled && isForge;
    const [advSupportOpen, setAdvSupportOpen] = React.useState(false);
    const advSupportButton = [];
    if (advSupportAllowed && !inEmulation) {
        advSupportButton.push({
            text: 'Advanced Support',
            props: { color: 'secondary', name: 'button-advSupport' },
            onClick: () => setAdvSupportOpen(true),
        });
    }
    return (React.createElement(StyledAboutBox, { title: title, open: open, cancelText: "Close", onCancel: () => setOpen(false), dividers: 'both', dialogProps: {
            PaperProps: {
                square: false,
                onClick: undefined,
            },
            maxWidth: 'md',
        }, otherActions: advSupportButton },
        React.createElement(AboutBoxContent, { banner: banner, textboxSrc: textboxSrc, textBoxContent: textBoxContent }),
        advSupportAllowed && (React.createElement(UserEmulation, { open: advSupportOpen, setOpen: setAdvSupportOpen }))));
};
export default AboutBox;
